/* eslint-disable @next/next/no-img-element */
// js
// utils
import Link from 'next/link';
import { useState } from 'react';
import { FaFacebook, FaHeart, FaShareAlt, FaWhatsapp } from "react-icons/fa";
import { FiMail } from "react-icons/fi";
import { SlArrowDown } from "react-icons/sl";
import { trackLead } from '../../whatsAppButton/WhatsAppButton';
import styles from './FavoritosComponent.module.css';

const FavoritosComponent: React.FC<{ site: any, favorito: any, compartilhar?: boolean, setOpenFavoritos?: any, zeraFiltros?: any, codsite?: any, setAuxiliar?: any,setAutorizaBusca?: any}> = ({ codsite, site, favorito, compartilhar, setOpenFavoritos, zeraFiltros,setAuxiliar,setAutorizaBusca }) => {
    const renderText = () => {
        return `/imoveis/${site?.transacoes[0].toLowerCase()}/-/-/-/-?favoritos=${favorito}${codsite ? '&codsite='+codsite : ''}`;
    };
    const renderURL = () => {
        return `${site?.site}/imoveis/${site?.transacoes[0].toLowerCase()}/-/-/-/-?favoritos=${favorito}${codsite ? '&codsite='+codsite : ''}`;
    };
    const renderOpen = () => {
        if(zeraFiltros){
            zeraFiltros();
        }
        if(setAuxiliar){
            setAuxiliar(true)
        }
        setOpenFavoritos(true)
        if(setAutorizaBusca)
            setAutorizaBusca(true);
    };
    const [openIcons, setOpenIcons] = useState(0);

    if(compartilhar){
        return (
            openIcons ?
                <div className={openIcons ? styles.logo_favoritos_columns_cli : styles.logo_favoritos_columns}>
                    <div className={styles.text1}><SlArrowDown size={20} color="#000000" onClick={()=>setOpenIcons(0)} /></div>
                    <a
                        rel="noopener noreferrer"
                        href={"https://api.whatsapp.com/send?text=https://"+renderURL()}
                        onClick={async (e) => {
                            e.preventDefault(); // Evita o redirecionamento automático
                        
                            trackLead(site, null); // 🔥 Registra o evento Lead
                        
                            // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                            setTimeout(() => {
                            window.open(
                                "https://api.whatsapp.com/send?text=https://"+renderURL(),
                                "_blank"
                            );
                            }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                        }}
                        title='Clique para ver seus imóveis Favoritos'
                        className={styles.text}
                    >
                        <FaWhatsapp size={30} color="#42a838"/>
                    </a>
                    <a
                        rel="noopener noreferrer"
                        href={"https://api.whatsapp.com/send?text=https://"+renderURL()}
                        onClick={async (e) => {
                            e.preventDefault(); // Evita o redirecionamento automático
                        
                            trackLead(site, null); // 🔥 Registra o evento Lead
                        
                            // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                            setTimeout(() => {
                            window.open(
                                "https://www.facebook.com/sharer/sharer.php?u=https://"+renderURL(),
                                "_blank"
                            );
                            }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                        }}
                        title='Clique para ver seus imóveis Favoritos'
                        className={styles.text}
                    >
                        <FaFacebook size={30} color="#385898"/>
                    </a>
                    <a
                        rel="noopener noreferrer"
                        href={"mailto:?subject=https://"+renderURL()}
                        onClick={async (e) => {
                            e.preventDefault(); // Evita o redirecionamento automático
                        
                            trackLead(site, null); // 🔥 Registra o evento Lead
                        
                            // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                            setTimeout(() => {
                            window.open(
                                "mailto:?subject=https://"+renderURL(),
                                "_blank"
                            );
                            }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                        }}
                        title='Clique para ver seus imóveis Favoritos'
                        className={styles.text}
                    >
                        <FiMail size={30} color="#6b6868"/>
                    </a>
                </div>
            :
                <div className={styles.logo_favoritos}>
                    <div
                        onClick={() => setOpenIcons(1)}
                    >
                        <FaShareAlt size={40} color="#0000FF"/>
                    </div>
                </div>
        )
    }else{
        return (
            <div className={styles.logo_favoritos}>
                { setOpenFavoritos ?
                    <div
                        onClick={() => renderOpen()}
                    >
                        <FaHeart size={40} color="red"/>
                    </div>
                :
                    <Link prefetch={false} href={renderText()} rel="noopener noreferrer" target="_blank" passHref>
                        <div
                            title='Clique para ver seus imóveis Favoritos'
                        >
                            <FaHeart size={40} color="red"/>
                        </div>
                    </Link>
                }
            </div>
        );
    }

};

export default FavoritosComponent;
